import { Component } from '@angular/core';
import { EditDialogService } from '../../../utility/dialog/edit-dialog-service';
import { AddJobComponent } from './add-job.component'; 
import { LoginService } from '../../../../services/login-service';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from '../../../utility/http-service';
import { RouterService } from '../../../utility/router-service';


@Component({
  selector: 'app-job-grid',
  templateUrl: './job-grid.component.html',
  styleUrls: ['./job-grid.component.css'], 
  standalone: false
})


export class JobGridComponent {

  constructor(public dialogService: EditDialogService, public loginService: LoginService, private dialog: MatDialog, private httpService: HttpService,
    private router: RouterService) { }


  onAdd(): void {
    this.dialog.open(AddJobComponent, {
      data: null,
      minWidth: '1200px',
      minHeight: 'max-content'
    }).afterClosed().subscribe(result => {
      if (result && result.success) {
        this.router.reloadPage();
      }
    });
  }

  onEdit(selectedRecord: (Record<string, any> | null | undefined)): void {
    if (!selectedRecord) {
      this.dialogService.showError('No record selected');
      return;
    }

    this.httpService.get(`Fracx/GetSyncOption?id=${selectedRecord['RecordId']}`, (x: any) => {

      this.dialog.open(AddJobComponent, {
        data: x,
        minWidth: '1200px',
        minHeight: 'max-content',
        panelClass: 'edit-dialog'
      }).afterClosed().subscribe(result => {
        if (result && result.success) {
          this.router.reloadPage();
        }
      });
    });
  }
}


